var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPjm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 18.8,
    stroke: "#B5B5B5",
    strokeWidth: 2.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0365 20.1616H12.5981C12.8285 20.1616 13.0504 20.1445 13.2637 20.1104C13.4771 20.0763 13.6648 20.0123 13.8269 19.9184C13.9891 19.816 14.1171 19.6752 14.2109 19.496C14.3133 19.3168 14.3645 19.0821 14.3645 18.792C14.3645 18.5019 14.3133 18.2672 14.2109 18.088C14.1171 17.9088 13.9891 17.7723 13.8269 17.6784C13.6648 17.576 13.4771 17.5077 13.2637 17.4736C13.0504 17.4395 12.8285 17.4224 12.5981 17.4224H11.0365V20.1616ZM9.02695 15.8608H13.1485C13.7203 15.8608 14.2067 15.9461 14.6077 16.1168C15.0088 16.2789 15.3331 16.4965 15.5805 16.7696C15.8365 17.0427 16.02 17.3541 16.1309 17.704C16.2504 18.0539 16.3101 18.4165 16.3101 18.792C16.3101 19.1589 16.2504 19.5216 16.1309 19.88C16.02 20.2299 15.8365 20.5413 15.5805 20.8144C15.3331 21.0875 15.0088 21.3093 14.6077 21.48C14.2067 21.6421 13.7203 21.7232 13.1485 21.7232H11.0365V25H9.02695V15.8608ZM19.3564 17.3584H17.5388V15.8608H19.3564V17.3584ZM16.4508 25.768C16.5447 25.8021 16.6727 25.8192 16.8348 25.8192C17.0226 25.8192 17.1847 25.7808 17.3212 25.704C17.4663 25.6357 17.5388 25.4779 17.5388 25.2304V18.3824H19.3564V25.32C19.3564 25.6613 19.318 25.9557 19.2412 26.2032C19.173 26.4507 19.0492 26.6555 18.87 26.8176C18.6994 26.9883 18.4647 27.112 18.166 27.1888C17.8674 27.2741 17.4876 27.3168 17.0268 27.3168C16.8135 27.3168 16.6215 27.2997 16.4508 27.2656V25.768ZM21.1269 15.8608H23.9557L26.0933 22.1456H26.1189L28.1413 15.8608H30.9701V25H29.0885V18.5232H29.0629L26.8229 25H25.2741L23.0341 18.5872H23.0085V25H21.1269V15.8608Z",
    fill: "#B5B5B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPjm);
export default __webpack_public_path__ + "static/media/icon-pjm.53abf1cd6e88b98dbe54057dadef4a69.svg";
export { ForwardRef as ReactComponent };